var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00857C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.3,1.3c-0.4,0.4-0.4,1,0,1.4L9.6,8l-5.3,5.3c-0.4,0.4-0.4,1,0,1.4l0,0C4.5,14.9,4.7,15,5,15s0.5-0.1,0.7-0.3 l6-6C11.9,8.5,12,8.3,12,8l0,0c0-0.3-0.1-0.5-0.3-0.7l-6-6C5.5,1.1,5.3,1,5,1S4.5,1.1,4.3,1.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/right-button.2eed370e23a33d635b1bc12e0bafafb6.svg";
export { ForwardRef as ReactComponent };